// حذف الحساب — الفعل الوحيد في التطبيق الذي لا يُسترجع بأي رمز.
//
// ثلاث قواعد تحكم هذه الشاشة:
// ١) قُل ما سيحدث بالضبط قبل أن تسأل. والنصّ يختلف: من كان وحده تُحذف محفظته،
//    ومن معه أهله تنتقل الملكية وتبقى الحركات. الغموض هنا أسوأ من التحذير.
// ٢) اعرض التصدير في الطريق. من قرّر الحذف لن يعود إلى الإعدادات ليبحث عن زرّ.
// ٣) حاجزان: كلمة المرور يتحقّق منها الخادم، واسم المستخدم يُكتب هنا ليمنع
//    الضغط العابر.

import { esc } from '../util.js';
import { state, clearLocal } from '../store.js';
import { api, ApiError } from '../api.js';
import { backBar } from '../ui.js';
import { exportBackup } from './settings.js';
import * as authView from './auth.js';

export function freshDraft(){
  return { password: '', username: '', busy: false };
}

/** الأعضاء الآخرون في المحفظة — هم من يحدّد مصيرها بعد الحذف. */
function others(){
  return (state.members || []).filter(m => m.id !== state.user.id);
}

function fate(){
  const rest = others();
  if (!rest.length){
    return `أنت وحدك في هذه المحفظة، فستُحذف معك: <b>كل الحركات والوجهات
            والأنواع</b>. لن يبقى منها شيء.`;
  }
  if (state.user.role !== 'owner'){
    return `المحفظة مشتركة، فتبقى هي وحركاتها كما هي لبقية الأعضاء.
            وحركاتك التي سجّلتها تبقى فيها بلا اسمك.`;
  }
  const heir = rest.length === 1
    ? `<b>${esc(rest[0].displayName || rest[0].username)}</b>`
    : 'أقدم عضو فيها';
  return `أنت مالك محفظة مشتركة. ستنتقل ملكيتها إلى ${heir}، وتبقى الحركات
          كلها — بما فيها حركاتك — لبقية الأعضاء.`;
}

export function render(app){
  const d = app.accountDraft;

  return backBar('حذف الحساب', 'لا رجعة فيه — ولا يُستعاد برمز الاسترجاع')
    + `<div class="scroll">
      <div class="card">
        <h3>ماذا سيحدث</h3>
        <p class="desc">${fate()}</p>
        <p class="desc">سيُغلق حسابك على كل أجهزتك فوراً، ويتحرّر اسم المستخدم
          <b>${esc(state.user.username)}</b> لمن أراد استعماله لاحقاً.</p>
      </div>

      <div class="card">
        <h3>قبل أن تحذف</h3>
        <p class="desc">صدّر نسخة من بياناتك. بعد الحذف لا سبيل إلى استرجاعها.</p>
        <div class="btnrow">
          <button type="button" class="btn" data-act="export">صدّر نسخة</button>
        </div>
      </div>

      <div class="card">
        <h3>تأكيد</h3>
        <div class="field">
          <label for="acPass">كلمة المرور</label>
          <input id="acPass" type="password" autocomplete="current-password"
                 value="${esc(d.password)}">
        </div>
        <div class="field">
          <label for="acName">اكتب اسم المستخدم «${esc(state.user.username)}»</label>
          <input id="acName" type="text" autocomplete="off" dir="ltr"
                 value="${esc(d.username)}">
        </div>
        <div class="btnrow">
          <button type="button" class="btn danger" data-act="ac-delete"
                  ${d.busy ? 'disabled' : ''}>احذف حسابي نهائياً</button>
        </div>
      </div>
    </div>`;
}

export function mount(app, root){
  const d = app.accountDraft;
  const pass = root.querySelector('#acPass');
  const name = root.querySelector('#acName');
  // لا نُعيد الرسم عند الكتابة: إعادة الرسم تُفقد التركيز ومكان المؤشّر
  if (pass) pass.oninput = () => { d.password = pass.value; };
  if (name) name.oninput = () => { d.username = name.value; };
}

export function onClick(app, btn){
  if (btn.dataset.act === 'export') return exportBackup(app);
  if (btn.dataset.act === 'ac-delete') return runDelete(app);
  return false;
}

async function runDelete(app){
  const d = app.accountDraft;

  if (d.username.trim() !== state.user.username){
    app.toast('اكتب اسم المستخدم كما هو لتأكيد الحذف');
    return true;
  }
  if (!d.password){
    app.toast('أدخل كلمة المرور');
    return true;
  }

  d.busy = true;
  app.render();
  try {
    await api.deleteAccount(d.password);
    clearLocal();
    app.session = null;
    app.sub = null;
    app.accountDraft = null;
    app.authDraft = authView.freshDraft();
    app.render();
    app.toast('حُذف حسابك');
  } catch (err){
    d.busy = false;
    app.toast(err instanceof ApiError && err.isOffline
      ? 'الحذف يحتاج اتصالاً'
      : (err.message || 'تعذّر حذف الحساب'));
    app.render();
  }
  return true;
}
